import React from 'react';
import { FormControlLabel } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import MuiSwitch from '@mui/material/Switch';
import Label from '../Label';
import { colors } from '../../css';

const MainSwitch = withStyles({
  switchBase: {
    color: colors.colorGrey03,
    '&$checked': {
      color: colors.colorWhite
    },
    '&$checked + $track': {
      backgroundColor: colors.colorBlue03
    }
  },
  checked: {},
  track: {}
})(MuiSwitch);

function Switch({ label, classes, description, toolTip, customLabel, labelPlacement, ...other }) {
  return (
    <FormControlLabel
      control={<MainSwitch {...other} color="primary" classes={classes} />}
      label={customLabel || <Label label={label} description={description} toolTip={toolTip} />}
      labelPlacement={labelPlacement || 'end'}
    />
  );
}

export default Switch;
